import { createContext, useContext } from "react";
import type { ToastInput } from "./toastStore";

export interface ToastContextValue {
  showToast(input: ToastInput): string;
  updateToast(id: string, patch: ToastInput): void;
  dismissToast(id: string): void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return context;
}
